(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('fareClasses', {
                parent: 'app',
                url: '/tariffClass/list',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/rates/tariffClass/tariffClasses.html',
                        controller: 'tariffClassCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['fareClass', 'category']);
                            }],
                            'cabins': ['tariffClassService', function (tariffClassService) {
                                return tariffClassService.getCabins()
                            }],
                            'fareClasses': ['tariffClassService', function (tariffClassService) {
                                return tariffClassService.getFareClasses()
                            }]
                        }
                    }
                }
            })
            .state('tariffClassNew', {
                parent: 'app',
                url: '/tariffClass/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/rates/tariffClass/tariffClassNew.html',
                        controller: 'tariffClassNewEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['fareClass', 'category']);
                            }],
                            edit: [function(){
                                return false;
                            }],
                            cabins: ['tariffClassService', function (tariffClassService) {
                                return tariffClassService.getCabins()
                            }],
                            fareClass: [function() {
                                return {};
                            }]
                        }
                    }
                }
            })
            .state('tariffClassEdit', {
                parent: 'app',
                url: '/tariffClass/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/rates/tariffClass/tariffClassEdit.html',
                        controller: 'tariffClassNewEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['fareClass', 'category']);
                            }],
                            edit: [function(){
                                return true;
                            }],
                            cabins: ['tariffClassService', function (tariffClassService) {
                                return tariffClassService.getCabins()
                            }],
                            fareClass: ['tariffClassService', '$stateParams', function (tariffClassService, $stateParams) {
                                return tariffClassService.getFareClass($stateParams.id)
                            }]
                        }
                    }
                }
            })
            .state('tariffClassDelete',{
                parent: 'fareClasses',
                url: '/tariffClass/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams','$state','$uibModal','linkService', function($stateParams,$state,$uibModal,linkService){
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/rates/tariffClass/tariffClassDelete.html',
                        controller: 'modalTariffClassDeleteCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'fareClass': ['tariffClassService', function (tariffClassService) {
                                return tariffClassService.getFareClass($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        linkService.reloadRoute('fareClasses');
                    }, function() {
                        linkService.reloadRoute('^');
                    });
                }]
            })
    }
})();

